/* Validación de interfaz para Powerful Form Builder. No sustituye la validación del servidor. */
(() =>
{
  'use strict';

  if (window.validacionCorreoFormulariosInstalada)
  {
    return;
  }
  window.validacionCorreoFormulariosInstalada = true;

  const selectorFormulario = '.globo-formbuilder, .globo-form-app';
  const selectorCorreo = 'input[type="email"], input[autocomplete="email"]';
  const mensaje = 'Introduce un correo electrónico de contacto válido. No se permiten direcciones de prueba.';
  const avisos = new WeakMap();
  let numeroAviso = 0;

  function obtenerFormulario(elemento)
  {
    if (!(elemento instanceof Element))
    {
      return null;
    }
    const contenedor = elemento.closest(selectorFormulario)
      || elemento.form?.closest(selectorFormulario);
    if (!contenedor)
    {
      return null;
    }
    const formulario = elemento.closest('form') || elemento.form;
    return formulario && contenedor.contains(formulario) ? formulario : contenedor;
  }

    function estaBloqueado(campo)
    {
    if (campo.disabled)
    {
        return false;
    }

    const correo = campo.value.trim().toLowerCase();
    const posicionArroba = correo.lastIndexOf('@');

    if (posicionArroba === -1)
    {
        return false;
    }

    const dominio = correo.slice(posicionArroba + 1);

    // Bloquea "example" como parte completa del dominio.
    // Ejemplos: example.com, example.org, mail.example.com.
    return /(^|\.)(example|testing)(\.|$)/.test(dominio);
    }

  function mostrarAviso(campo)
  {
    let estado = avisos.get(campo);
    if (!estado)
    {
      const aviso = document.createElement('span');
      aviso.id = 'aviso-correo-bloqueado-' + (++numeroAviso);
      aviso.className = 'aviso-correo-bloqueado';
      aviso.setAttribute('role', 'alert');
      aviso.textContent = mensaje;
      aviso.style.cssText = 'display:block;width:100%;color:#b42318;font-size:14px;line-height:1.4;margin:8px 0 0;';
      estado =
      {
        aviso,
        validezAnterior:campo.validity.customError ? campo.validationMessage : '',
        invalidoAnterior:campo.getAttribute('aria-invalid')
      };
      avisos.set(campo, estado);
      campo.insertAdjacentElement('afterend', aviso);
      const descripciones = (campo.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      descripciones.push(aviso.id);
      campo.setAttribute('aria-describedby', descripciones.join(' '));
    }
    campo.setCustomValidity(mensaje);
    campo.setAttribute('aria-invalid', 'true');
  }

  function quitarAviso(campo)
  {
    const estado = avisos.get(campo);
    if (!estado)
    {
      return;
    }
    if (campo.validationMessage === mensaje)
    {
      campo.setCustomValidity(estado.validezAnterior);
    }
    if (campo.getAttribute('aria-invalid') === 'true')
    {
      if (estado.invalidoAnterior === null)
      {
        campo.removeAttribute('aria-invalid');
      }
      else
      {
        campo.setAttribute('aria-invalid', estado.invalidoAnterior);
      }
    }
    const descripciones = (campo.getAttribute('aria-describedby') || '').split(/\s+/)
      .filter(id => id && id !== estado.aviso.id);
    if (descripciones.length)
    {
      campo.setAttribute('aria-describedby', descripciones.join(' '));
    }
    else
    {
      campo.removeAttribute('aria-describedby');
    }
    estado.aviso.remove();
    avisos.delete(campo);
  }

  function revisarCampo(evento)
  {
    const campo = evento.target;
    if (!(campo instanceof HTMLInputElement) || !campo.matches(selectorCorreo) || !obtenerFormulario(campo))
    {
      return;
    }
    // Mostrar el error al salir del campo o intentar enviar; al escribir, liberar una corrección.
    if (!estaBloqueado(campo))
    {
      quitarAviso(campo);
    }
    else if (evento.type !== 'input')
    {
      mostrarAviso(campo);
    }
  }

  function validarAntesDeEnviar(evento, elemento)
  {
    const formulario = obtenerFormulario(elemento);
    if (!formulario)
    {
      return;
    }
    let primerCampo = null;
    for (const campo of formulario.querySelectorAll(selectorCorreo))
    {
      if (estaBloqueado(campo))
      {
        mostrarAviso(campo);
        primerCampo ||= campo;
      }
      else
      {
        quitarAviso(campo);
      }
    }
    if (!primerCampo)
    {
      return; // Dejar que la aplicación y reCAPTCHA continúen normalmente.
    }
    evento.preventDefault();
    evento.stopImmediatePropagation();
    if (primerCampo.getClientRects().length)
    {
      primerCampo.focus();
      primerCampo.reportValidity();
    }
  }

  function comprobarBoton(evento)
  {
    if (!(evento.target instanceof Element))
    {
      return;
    }
    const boton = evento.target.closest('button, input[type="submit"], input[type="image"], [role="button"]');
    if (!boton || boton.disabled || !obtenerFormulario(boton))
    {
      return;
    }
    const tipo = (boton.getAttribute('type') || '').toLowerCase();
    if (tipo === 'reset')
    {
      return;
    }
    const esEnvioNativo = boton.matches('input[type="submit"], input[type="image"], button[type="submit"], button:not([type])');
    // Algunas versiones del widget usan type="button" con el texto Enviar.
    const texto = (boton.textContent || boton.value || boton.getAttribute('aria-label') || '').trim();
    const esEnvioAplicacion = /^(enviar|submit|send|envoyer|senden)(?:\s|$)/i.test(texto);
    if (esEnvioNativo || esEnvioAplicacion)
    {
      validarAntesDeEnviar(evento, boton);
    }
  }

  // Captura en window: actuar antes de los manejadores habituales del widget.
  // Delegación: cubre formularios insertados después y recargas del editor de Shopify.
  window.addEventListener('input', revisarCampo, true);
  window.addEventListener('change', revisarCampo, true);
  window.addEventListener('focusout', revisarCampo, true);
  window.addEventListener('click', comprobarBoton, true);
  window.addEventListener('submit', evento => validarAntesDeEnviar(evento, evento.target), true);
  window.addEventListener('keydown', evento =>
  {
    if (evento.key === 'Enter' && !evento.isComposing && evento.target instanceof HTMLInputElement
      && evento.target.matches('input[type="email"], input[type="text"], input[type="tel"], input:not([type])'))
    {
      validarAntesDeEnviar(evento, evento.target);
    }
  }, true);
  window.addEventListener('reset', evento =>
  {
    const formulario = obtenerFormulario(evento.target);
    if (!formulario)
    {
      return;
    }
    setTimeout(() =>
    {
      if (evento.defaultPrevented)
      {
        return;
      }
      for (const campo of formulario.querySelectorAll(selectorCorreo))
      {
        quitarAviso(campo);
      }
    }, 0);
  }, true);
})();
